export const pathsA = [
  {
    i: 0,
    d: 'm17.98,1.7l-.31,3.44c-.91-.11-1.85-.11-2.8.01l-.5-3.41c1.23-.16,2.43-.17,3.61-.04Z'
  },
  {
    i: 3.4577,
    d: 'm21.33,2.48l-1.11,3.26c-.83-.3-1.68-.5-2.55-.6l.31-3.44c1.15.12,2.27.39,3.35.78Z'
  },
  {
    i: 5.4009,
    d: 'm24.32,3.97l-1.79,2.93c-.74-.48-1.51-.86-2.31-1.16l1.11-3.26c1.03.38,2.03.87,2.99,1.49Z'
  },
  {
    i: 6.8247,
    d: 'm26.92,6.02l-2.32,2.52s-.09-.09-.14-.14c-.61-.58-1.26-1.08-1.93-1.5l1.79-2.93c.86.55,1.69,1.19,2.48,1.93.04.04.08.08.12.12Z'
  },
  {
    i: 7.9637,
    d: 'm29.09,8.5l-2.73,2.08c-.53-.74-1.11-1.42-1.76-2.04l2.32-2.52c.8.76,1.52,1.59,2.17,2.48Z'
  },
  {
    i: 8.919,
    d: 'm30.82,11.33l-3.04,1.6c-.41-.82-.88-1.61-1.42-2.35l2.73-2.08c.66.89,1.23,1.84,1.73,2.83Z'
  },
  {
    i: 9.7454,
    d: 'm32.08,14.4l-3.26,1.1c-.28-.88-.62-1.74-1.04-2.57l3.04-1.6c.5.99.93,2.02,1.26,3.07Z'
  },
  {
    i: 10.4765,
    d: 'm32.83,17.61l-3.39.57c-.13-.9-.34-1.8-.62-2.68l3.26-1.1c.34,1.05.59,2.13.75,3.21Z'
  },
  {
    i: 11.1353,
    d: 'm33.04,20.88l-3.43-.02c.02-.88-.03-1.78-.17-2.68l3.39-.57c.17,1.09.24,2.19.21,3.27Z'
  },
  {
    i: 11.7379,
    d: 'm33.04,20.88c-.02,1.1-.14,2.19-.37,3.24l-3.37-.68c.19-.83.29-1.7.31-2.58l3.43.02Z'
  },
  {
    i: 12.2969,
    d: 'm32.67,24.12c-.06.28-.13.56-.2.83-.22.79-.49,1.55-.82,2.26l-3.15-1.38c.29-.61.5-1.22.66-1.79.05-.2.1-.4.14-.6l3.37.68Z'
  },
  {
    i: 12.822,
    d: 'm31.65,27.21c-.46,1.02-1.03,1.96-1.72,2.82l-2.73-2.07c.56-.7.98-1.42,1.3-2.13l3.15,1.38Z'
  },
  {
    i: 13.3212,
    d: 'm29.93,30.03c-.7.91-1.53,1.72-2.46,2.42l-2.11-2.67c.74-.57,1.35-1.18,1.84-1.82l2.73,2.07Z'
  },
  {
    i: 13.8013,
    d: 'm27.47,32.45c-.95.74-2,1.36-3.16,1.86l-1.42-3.1c.95-.42,1.77-.9,2.47-1.43l2.11,2.67Z'
  },
  {
    i: 14.2685,
    d: 'm24.31,34.31c-1.07.48-2.22.85-3.46,1.13-.13.03-.26.06-.39.07l-.72-3.34c.12-.02.25-.04.37-.07,1.04-.23,1.96-.53,2.78-.89l1.42,3.1Z'
  },
  {
    i: 14.7283,
    d: 'm20.46,35.51c-1.18.25-2.33.36-3.43.36-.1,0-.2,0-.3-.01l.03-3.43c.96.03,1.95-.05,2.98-.26l.72,3.34Z'
  },
  {
    i: 15.1859,
    d: 'm16.76,32.43l-.03,3.43c-1.22-.01-2.38-.17-3.49-.45l.78-3.35h.01c.87.22,1.78.35,2.73.37Z'
  },
  {
    i: 15.6467,
    d: 'm14.02,32.06l-.78,3.35c-1.12-.27-2.18-.66-3.18-1.16l1.49-3.12c.78.39,1.6.71,2.47.93Z'
  },
  {
    i: 16.1158,
    d: 'm11.55,31.13l-1.49,3.12c-1-.49-1.94-1.09-2.81-1.77l2.09-2.75c.69.54,1.43,1.01,2.21,1.4Z'
  },
  {
    i: 16.5988,
    d: 'm9.34,29.73l-2.09,2.75c-.86-.67-1.66-1.43-2.39-2.25l2.55-2.32c.58.67,1.23,1.28,1.93,1.82Z'
  },
  {
    i: 17.6326,
    d: 'm7.41,27.91l-2.55,2.32c-.72-.81-1.37-1.69-1.94-2.62l2.9-1.84c.47.76,1,1.48,1.59,2.14Z'
  },
  {
    i: 18.1985,
    d: 'm5.82,25.77l-2.9,1.84c-.57-.93-1.07-1.91-1.47-2.91l3.15-1.33c.34.83.75,1.63,1.22,2.4Z'
  },
  {
    i: 18.8101,
    d: 'm4.6,23.37l-3.15,1.33c-.29-.7-.54-1.4-.74-2.12-.09-.32-.17-.64-.24-.97l3.33-.8c.06.29.13.56.21.84.16.58.36,1.16.59,1.72Z'
  },
  {
    i: 19.4802,
    d: 'm3.8,20.81l-3.33.8c-.24-1.05-.39-2.13-.44-3.21l3.43-.2c.03.9.15,1.77.34,2.61Z'
  },
  {
    i: 20.226,
    d: 'm3.46,18.2l-3.43.2c-.06-1.07-.02-2.15.12-3.22l3.41.44c-.12.86-.16,1.73-.1,2.58Z'
  },
  {
    i: 21.0718,
    d: 'm4.15,13.15c-.29.81-.48,1.64-.59,2.47l-3.41-.44c.15-1.07.39-2.13.76-3.15l3.24,1.12Z'
  },
  {
    i: 22.0538,
    d: 'm5.25,10.88c-.46.73-.82,1.49-1.1,2.27l-3.24-1.12c.35-1.03.83-2.02,1.42-2.96l2.92,1.81Z'
  },
  {
    i: 23.2319,
    d: 'm6.9,8.86c-.65.62-1.2,1.31-1.65,2.02l-2.92-1.81c.59-.94,1.3-1.83,2.15-2.65l2.42,2.44Z'
  },
  {
    i: 24.7198,
    d: 'm9.15,7.14c-.86.51-1.61,1.09-2.25,1.72l-2.42-2.44c.83-.81,1.78-1.55,2.87-2.2l1.8,2.92Z'
  },
  {
    i: 26.7965,
    d: 'm12.07,5.8h-.01c-1.09.37-2.06.83-2.91,1.34l-1.8-2.92c1.06-.64,2.25-1.2,3.58-1.65l1.14,3.23Z'
  },
  {
    i: 31.0,
    d: 'm14.87,5.15c-.92.11-1.86.32-2.8.65l-1.14-3.23h.01c1.15-.4,2.3-.68,3.43-.83l.5,3.41Z'
  }
]

export const pathsB = [
  {
    i: 0.0,
    d: 'm65.23.55l-.78,3.34c-1.23-.31-2.47-.47-3.66-.47V0c1.47,0,2.96.19,4.44.55'
  },
  {
    i: 1.6242,
    d: 'm68.82,1.78l-1.34,3.16c-.99-.44-2.01-.8-3.03-1.05l.78-3.34c1.22.3,2.42.71,3.59,1.23'
  },
  {
    i: 3.2436,
    d: 'm72.2,3.59l-1.83,2.92c-.92-.61-1.89-1.14-2.89-1.57l1.34-3.16c1.17.5,2.3,1.11,3.38,1.81'
  },
  {
    i: 4.8535,
    d: 'm75.26,5.96l-2.27,2.57c-.81-.75-1.69-1.43-2.62-2.02l1.83-2.92c1.08.7,2.11,1.49,3.06,2.37'
  },
  {
    i: 6.4491,
    d: 'm77.88,8.79l-2.69,2.13c-.27-.37-.57-.73-.89-1.08-.41-.46-.85-.9-1.31-1.31l2.27-2.57c.56.5,1.09,1.03,1.59,1.59.36.41.71.82,1.03,1.24'
  },
  {
    i: 8.0259,
    d: 'm79.91,12.04l-3.04,1.55c-.45-.92-1.01-1.81-1.68-2.67l2.69-2.13c.81,1.04,1.49,2.13,2.03,3.25'
  },
  {
    i: 9.579,
    d: 'm81.23,15.65l-3.33.83c-.23-.98-.57-1.94-1.03-2.89l3.04-1.55c.59,1.17,1.03,2.38,1.32,3.61'
  },
  {
    i: 11.1041,
    d: 'm81.64,19.54l-3.42-.04c.02-1-.08-2.01-.32-3.02l3.33-.83c.3,1.28,.45,2.59,.41,3.89'
  },
  {
    i: 12.5967,
    d: 'm81.64,19.54c0,.41-.03.83-.07,1.24-.12,1.14-.32,2.18-.58,3.15l-3.31-.84c.21-.81,.38-1.7,.48-2.67,.03-.31,.05-.61,.06-.92l3.42.04'
  },
  {
    i: 14.0523,
    d: 'm80.99,23.93h0c-.37,1.43-.89,2.67-1.49,3.79l-3.04-1.61c.5-.9,.91-1.89,1.22-3.02l3.31.84'
  },
  {
    i: 15.4666,
    d: 'm79.5,27.72c-.62,1.12-1.34,2.12-2.11,3.02l-2.63-2.21c.64-.74,1.21-1.53,1.7-2.42l3.04,1.61'
  },
  {
    i: 16.8356,
    d: 'm77.39,30.74c-.77.89-1.59,1.7-2.44,2.45l-2.31-2.52c.76-.68,1.48-1.38,2.12-2.14l2.63,2.21'
  },
  {
    i: 18.1552,
    d: 'm74.95,33.19c-.75.68-1.52,1.32-2.28,1.96-.08.07-.17.14-.25.21l-2.23-2.61c.1-.08,.19-.15,.28-.23.75-.62,1.48-1.23,2.17-1.85l2.31,2.52'
  },
  {
    i: 19.4216,
    d: 'm72.42,35.36c-.84.71-1.67,1.4-2.46,2.14l-2.37-2.49c.87-.81,1.75-1.55,2.6-2.26l2.23,2.61'
  },
  {
    i: 20.631,
    d: 'm69.96,37.5c-.79.73-1.55,1.5-2.25,2.36l-2.67-2.15c.81-1,1.68-1.88,2.55-2.7l2.37,2.49'
  },
  {
    i: 21.7799,
    d: 'm67.71,39.86c-.71.85-1.35,1.77-1.93,2.82l-3.02-1.61c.68-1.26,1.45-2.36,2.28-3.36l2.67,2.15Z'
  },
  {
    i: 22.8649,
    d: 'm65.78,42.68c-.11.2-.22.4-.32.61-.41.81-.77,1.64-1.09,2.49l-3.21-1.21c.37-.95.78-1.89,1.24-2.82.12-.23.23-.46.36-.68l3.02,1.61Z'
  },
  {
    i: 23.8828,
    d: 'm64.37,45.78c-.42,1.05-.77,2.12-1.1,3.2l-3.29-.95c.35-1.16.73-2.32,1.18-3.46l3.21,1.21Z'
  },
  {
    i: 24.8307,
    d: 'm63.27,48.98c-.33,1.1-.62,2.21-.9,3.32l-3.34-.82c.3-1.15.6-2.3.95-3.45l3.29.95Z'
  },
  {
    i: 25.7057,
    d: 'm62.37,52.3c-.17.64-.32,1.28-.48,1.91-.12.5-.25,1-.38,1.49l-3.33-.81c.13-.5.25-1,.38-1.51.16-.63.31-1.26.47-1.9l3.34.82Z'
  },
  {
    i: 26.5054,
    d: 'm61.51,55.7c-.28,1.15-.58,2.29-.92,3.43l-3.29-.93c.31-1.09.6-2.19.88-3.31l3.33.81Z'
  },
  {
    i: 27.2273,
    d: 'm60.59,59.13c-.33,1.15-.7,2.29-1.13,3.41l-3.21-1.18c.39-1.03.73-2.09,1.05-3.16l3.29.93Z'
  },
  {
    i: 27.8693,
    d: 'm59.46,62.54c-.43,1.14-.91,2.26-1.48,3.35l-3.05-1.55c.5-.96.93-1.96,1.32-2.98l3.21,1.18Z'
  },
  {
    i: 28.4296,
    d: 'm57.98,65.89c-.57,1.1-1.22,2.18-1.98,3.21l-2.79-2c.66-.88,1.22-1.81,1.72-2.76l3.05,1.55Z'
  },
  {
    i: 28.9065,
    d: 'm56,69.1c-.75,1.04-1.61,2.04-2.6,2.99l-2.4-2.45c.84-.8,1.57-1.65,2.21-2.54l2.79,2Z'
  },
  {
    i: 29.2986,
    d: 'm53.4,72.09c-.2.2-.41.4-.63.59-.77.69-1.58,1.32-2.42,1.89l-1.93-2.84c.72-.48,1.41-1.02,2.06-1.6.18-.16.35-.32.52-.49l2.4,2.45Z'
  },
  {
    i: 29.6048,
    d: 'm50.35,74.57c-1.07.71-2.19,1.33-3.36,1.84l-1.42-3.1c.99-.44,1.94-.97,2.85-1.58l1.93,2.84Z'
  },
  {
    i: 29.8241,
    d: 'm46.99,76.41c-1.16.54-2.36.96-3.59,1.28l-.9-3.28c1.05-.28,2.08-.64,3.07-1.1l1.42,3.1Z'
  },
  {
    i: 29.956,
    d: 'm43.4,77.69c-1.23.33-2.48.56-3.74.68l-.37-3.38c1.08-.1,2.16-.3,3.21-.58l.9,3.28Z'
  },
  {
    i: 30.0,
    d: 'm39.66,78.37c-.8.09-1.6.13-2.4.13-.46,0-.93-.01-1.39-.04l.18-3.4c1.07.06,2.16.04,3.24-.07l.37,3.38Z'
  },
  {
    i: 30.0333,
    d: 'm36.05,75.06l-.18,3.4c-1.27-.08-2.52-.26-3.75-.54l.75-3.33c1.04.25,2.1.4,3.18.47Z'
  },
  {
    i: 30.1333,
    d: 'm32.87,74.59l-.75,3.33c-1.24-.28-2.45-.67-3.61-1.17l1.33-3.15c.98.42,2,.75,3.03,.99Z'
  },
  {
    i: 30.3,
    d: 'm29.84,73.6l-1.33,3.15c-1.18-.5-2.31-1.1-3.37-1.82l1.9-2.86c.89.6,1.83,1.11,2.8,1.53Z'
  },
  {
    i: 30.5333,
    d: 'm27.04,72.07l-1.9,2.86c-.07-.04-.14-.09-.21-.14-1.3-.88-2.46-1.85-3.49-2.89l2.4-2.44c.88.89,1.9,1.73,3.03,2.5.06.04.11.08.17.11Z'
  },
  {
    i: 30.8333,
    d: 'm23.84,69.46l-2.4,2.44c-1.07-1.07-1.99-2.22-2.75-3.44l2.87-1.84c.63,1,1.39,1.95,2.28,2.84Z'
  },
  {
    i: 31.2,
    d: 'm21.56,66.62l-2.87,1.84c-.75-1.17-1.34-2.4-1.79-3.68l3.23-1.12c.35,1.03.83,2.01,1.43,2.96Z'
  },
  {
    i: 31.6333,
    d: 'm20.13,63.66l-3.23,1.12c-.42-1.22-.71-2.49-.84-3.78l3.4-.38c.1,1.04.33,2.06.67,3.04Z'
  },
  {
    i: 32.1333,
    d: 'm19.46,60.62l-3.4.38c-.14-1.23-.14-2.49,0-3.76l3.41.34c-.11,1.04-.11,2.05,0,3.04Z'
  },
  {
    i: 32.7,
    d: 'm20.09,54.62c-.24.76-.43,1.55-.55,2.35-.03.21-.06.41-.08.61l-3.41-.34c.03-.26.06-.52.1-.78.15-.96.37-1.91.66-2.84l3.28,1Z'
  },
  {
    i: 33.3333,
    d: 'm21.25,51.81c-.47.89-.86,1.83-1.16,2.81l-3.28-1c.36-1.17.84-2.31,1.41-3.39l3.03,1.58Z'
  },
  {
    i: 34.0333,
    d: 'm22.89,49.27c-.62.79-1.17,1.64-1.64,2.54l-3.03-1.58c.57-1.08,1.23-2.1,1.96-3.05l2.71,2.09Z'
  },
  {
    i: 34.8,
    d: 'm24.92,47.10c-.73.65-1.41,1.38-2.03,2.17l-2.71-2.09c.75-.94,1.57-1.83,2.46-2.61l2.28,2.53Z'
  },
  {
    i: 35.6333,
    d: 'm27.25,45.40c-.82.48-1.6,1.05-2.33,1.7l-2.28-2.53c.89-.8,1.84-1.51,2.85-2.11l1.76,2.94Z'
  },
  {
    i: 36.5333,
    d: 'm29.79,44.24c-.88.29-1.73.68-2.54,1.16l-1.76-2.94c1.02-.6,2.09-1.1,3.2-1.47l1.10,3.25Z'
  },
  {
    i: 37.5,
    d: 'm33.46,42.99c-1.07.41-2.22.80-3.43,1.17-.08.02-.16.05-.24.08l-1.10-3.25c.11-.04.22-.08.33-.11,1.16-.36,2.23-.72,3.23-1.09l1.21,3.20Z'
  },
  {
    i: 38.5333,
    d: 'm36.84,41.53c-1.04.52-2.16,1.01-3.38,1.46l-1.21-3.20c1.11-.41,2.12-.84,3.03-1.31l1.56,3.05Z'
  },
  {
    i: 39.6333,
    d: 'm39.77,39.75c-.88.65-1.86,1.23-2.93,1.78l-1.56-3.05c.90-.45,1.71-.94,2.42-1.48l2.07,2.75Z'
  },
  {
    i: 40.8,
    d: 'm42.20,37.50c-.70.83-1.51,1.57-2.43,2.25l-2.07-2.75c.70-.53,1.32-1.10,1.84-1.73l2.66,2.23Z'
  },
  {
    i: 42.0333,
    d: 'm44.02,34.65c-.49,1.06-1.10,2.00-1.82,2.85l-2.66-2.23c.53-.63.98-1.31,1.34-2.07l3.14,1.45Z'
  },
  {
    i: 43.3333,
    d: 'm45.12,31.22c-.25,1.27-.62,2.40-1.10,3.43l-3.14-1.45h0c.38-.80.67-1.68.87-2.66l3.37.68Z'
  },
  {
    i: 44.7,
    d: 'm45.52,27.16c-.02,1.49-.15,2.83-.40,4.06l-3.37-.68c.22-1.02.34-2.16.35-3.43l3.42.05Z'
  },
  {
    i: 46.1333,
    d: 'm45.52,27.16l-3.42-.05c.02-1.3-.06-2.73-.24-4.32l3.41-.40c.20,1.73.28,3.32.25,4.77Z'
  },
  {
    i: 47.6333,
    d: 'm45.27,22.39l-3.41.40c-.04-.35-.08-.71-.13-1.07-.15-1.07-.25-2.10-.30-3.11l3.43-.15c.04.89.13,1.82.27,2.78.05.39.10.77.14,1.15Z'
  },
  {
    i: 49.2,
    d: 'm44.86,18.46l-3.43.15c-.05-1.32,0-2.60.14-3.81l3.40.39c-.12,1.03-.15,2.12-.11,3.27Z'
  },
  {
    i: 50.8333,
    d: 'm45.59,12.28c-.29.90-.50,1.88-.62,2.91l-3.40-.39c.14-1.25.38-2.43.74-3.54l3.28,1.02Z'
  },
  {
    i: 52.5333,
    d: 'm46.68,9.76c-.45.77-.81,1.61-1.09,2.52l-3.28-1.02c.35-1.15.82-2.22,1.39-3.21l2.98,1.71Z'
  },
  {
    i: 54.3,
    d: 'm48.27,7.64c-.14.14-.27.28-.39.42-.45.52-.85,1.09-1.20,1.70l-2.98-1.71c.46-.80.99-1.54,1.58-2.23.17-.19.34-.38.52-.56l2.47,2.38Z'
  },
  {
    i: 56.1333,
    d: 'm50.41,5.90c-.80.51-1.51,1.09-2.14,1.74l-2.47-2.38c.82-.86,1.75-1.62,2.78-2.26l1.83,2.90Z'
  },
  {
    i: 58.0333,
    d: 'm53.17,4.57c-1.01.36-1.93.80-2.76,1.33l-1.83-2.90c1.04-.67,2.19-1.22,3.44-1.66l1.15,3.23Z'
  },
  {
    i: 60.0,
    d: 'm56.62,3.72c-1.25.19-2.40.47-3.45.85l-1.15-3.23c1.25-.45,2.61-.78,4.07-1.00l.53,3.38Z'
  },
  {
    i: 60.0,
    d: 'm60.79,0v3.42c-1.49,0-2.88.10-4.17.30l-.53-3.38c1.46-.23,3.03-.34,4.70-.34'
  }
]
